import React from 'react';
import CheckSquareUncheckedComponent from '@components/icons/checkSquareUnchecked';
import CheckmarkIconComponent from '@components/icons/checkmarkIcon';

function CheckboxComponent({
  name,
  onChange,
  errorMessage,
  children,
  isPasswordRemembered,
}: {
  name: string;
  onChange: (e: any) => void;
  errorMessage?: string;
  children: React.ReactNode;
  isPasswordRemembered?: boolean;
}) {
  return (
    <>
      <div className="relative flex items-start text-marketing-text-primary">
        <input
          type="checkbox"
          id={name}
          name={name}
          checked={isPasswordRemembered}
          onChange={onChange}
          className="peer absolute top-0 h-6 w-6 cursor-pointer opacity-0"
        />
        <CheckmarkIconComponent className="hidden h-6 w-6  flex-shrink-0 rounded-md border border-marketing-form-surface bg-marketing-form-surface peer-checked:block peer-hover:border-marketing-button-primary-hover"></CheckmarkIconComponent>
        {errorMessage ? (
          <CheckSquareUncheckedComponent className="h-6 w-6 flex-shrink-0 rounded-md border border-marketing-form-error  bg-marketing-form-surface text-marketing-form-surface peer-checked:hidden" />
        ) : (
          <CheckSquareUncheckedComponent
            className="h-6 w-6 flex-shrink-0 rounded-md border border-marketing-form-surface bg-marketing-form-surface   text-marketing-form-surface peer-checked:hidden
           peer-hover:border-marketing-button-primary-hover"
          />
        )}
        <label
          htmlFor={name}
          className="ml-4 text-start text-marketing-form-text"
        >
          {children}
        </label>
      </div>
    </>
  );
}

export default CheckboxComponent;
